import { render, staticRenderFns } from "./AddAccessory.vue?vue&type=template&id=c4c4494a"
import script from "./AddAccessory.vue?vue&type=script&lang=js"
export * from "./AddAccessory.vue?vue&type=script&lang=js"
import style0 from "./AddAccessory.vue?vue&type=style&index=0&id=c4c4494a&prod&lang=css"
import style1 from "./AddAccessory.vue?vue&type=style&index=1&id=c4c4494a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports